export default __webpack_public_path__ + "static/media/fi_violence.65628868.png";